var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-footer",
    { attrs: { app: "", fixed: "" } },
    [
      _c("span", { attrs: { id: "footer" } }, [
        _c(
          "a",
          { attrs: { href: "https://emcsoft.com.br", target: "_blank" } },
          [
            _c("v-img", {
              attrs: { src: "/img/emcsoft_logo.png", "max-width": "80" },
            }),
          ],
          1
        ),
      ]),
      _c("v-spacer"),
      _c(
        "span",
        { attrs: { id: "footer" } },
        [
          _vm.isStaging && _vm.user.is_internal
            ? _c(
                "v-chip",
                {
                  staticClass: "ma-2",
                  attrs: { color: "indigo", outlined: "", small: "" },
                },
                [
                  _c(
                    "v-icon",
                    { attrs: { small: "", left: "", color: "green" } },
                    [_vm._v("mdi-vuejs")]
                  ),
                  _vm._v("v" + _vm._s(_vm.vueVersion) + " "),
                ],
                1
              )
            : _vm._e(),
          _vm.isStaging && _vm.user.is_internal
            ? _c(
                "v-chip",
                {
                  staticClass: "ma-2",
                  attrs: { color: "indigo", outlined: "", small: "" },
                },
                [
                  _c(
                    "v-icon",
                    { attrs: { small: "", left: "", color: "blue" } },
                    [_vm._v("mdi-vuetify")]
                  ),
                  _vm._v("v" + _vm._s(_vm.vuetifyVersion) + " "),
                ],
                1
              )
            : _vm._e(),
          _vm.acesso.grupo != null
            ? _c(
                "span",
                { staticClass: "text-caption", attrs: { color: "white" } },
                [_c("strong", [_vm._v(_vm._s(_vm.footer))])]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }